// src/utils/request.js
import axios from 'axios';

// 创建 Axios 实例
const service = axios.create({
    baseURL: 'http://121.41.236.42:8088', // 替换为你的后端接口基础 URL
    timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        // 在发送请求之前做些什么，例如添加请求头
        // const token = localStorage.getItem('token');
        // if (token) {
        //   config.headers['Authorization'] = `Bearer ${token}`;
        // }
        return config;
    },
    (error) => {
        // 处理请求错误
        console.log(error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // 对响应数据做点什么
        const res = response.data;
        return res;
    },
    (error) => {
        // 处理响应错误
        console.log(`请求出错: ${error.message}`);
        return Promise.reject(error);
    }
);

// 封装请求方法
const request = {
    get(url, params = {}) {
        return service.get(url, { params });
    },
    post(url, data = {}) {
        return service.post(url, data);
    },
    put(url, data = {}) {
        return service.put(url, data);
    },
    delete(url, params = {}) {
        return service.delete(url, { params });
    }
};

export default request;
